(function () {
  function cleanText(value) {
    return String(value || '')
      .replace(/[\u200E\u200F\u202A-\u202E]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildButton(href, label, modifier) {
    if (!href || !label) return '';
    return '<a class="ot-policy-contact__button ' + modifier + '" href="' + escapeHtml(href) + '">' + escapeHtml(label) + '</a>';
  }

  function buildPill(href, label, external) {
    if (!href || !label) return '';

    var attrs = external ? ' target="_blank" rel="noopener noreferrer"' : '';
    return (
      '<a class="ot-policy-contact__pill" href="' +
      escapeHtml(href) +
      '"' +
      attrs +
      '>' +
      escapeHtml(label) +
      '</a>'
    );
  }

  function buildDetailCard(config) {
    if (!config.value && !config.title) return '';

    var label = config.label ? '<p class="ot-policy-contact__detail-label">' + escapeHtml(config.label) + '</p>' : '';
    var titleTag = config.title
      ? '<h2 class="ot-policy-contact__detail-title">' + escapeHtml(config.title) + '</h2>'
      : '';

    var valueHtml = '';
    if (config.value) {
      if (config.href) {
        var targetAttrs = config.external ? ' target="_blank" rel="noopener noreferrer"' : '';
        valueHtml =
          '<p class="ot-policy-contact__detail-value"><a href="' +
          escapeHtml(config.href) +
          '"' +
          targetAttrs +
          '>' +
          escapeHtml(config.value) +
          '</a></p>';
      } else {
        valueHtml = '<p class="ot-policy-contact__detail-value">' + escapeHtml(config.value) + '</p>';
      }
    }

    var copyHtml = config.copy
      ? '<p class="ot-policy-contact__detail-copy">' + escapeHtml(config.copy) + '</p>'
      : '';

    var actions = Array.isArray(config.actions) ? config.actions.filter(Boolean).join('') : '';
    var actionsHtml = actions ? '<div class="ot-policy-contact__detail-actions">' + actions + '</div>' : '';
    var modifierClass = config.modifier ? ' ' + config.modifier : '';

    return (
      '<article class="ot-policy-contact__detail' +
      modifierClass +
      '">' +
      label +
      titleTag +
      valueHtml +
      copyHtml +
      actionsHtml +
      '</article>'
    );
  }

  function enhanceContactPolicyPage() {
    if (!document.body.classList.contains('policy-contact-information')) return;

    var container = document.querySelector('.shopify-policy__container');
    var body = container ? container.querySelector('.shopify-policy__body .rte') : null;
    var title = container ? container.querySelector('.shopify-policy__title h1') : null;

    if (!container || !body) return;

    var paragraphs = Array.prototype.slice
      .call(body.querySelectorAll('p'))
      .map(function (paragraph) {
        return cleanText(paragraph.textContent);
      })
      .filter(Boolean);

    if (!paragraphs.length) return;

    var companyName = paragraphs.find(function (paragraph) {
      return paragraph.indexOf(':') === -1;
    }) || "Olivia's Tanghulu";

    var details = {};
    paragraphs.forEach(function (paragraph) {
      var separatorIndex = paragraph.indexOf(':');
      if (separatorIndex === -1) return;

      var key = cleanText(paragraph.slice(0, separatorIndex)).toLowerCase();
      var value = cleanText(paragraph.slice(separatorIndex + 1));
      if (key && value) details[key] = value;
    });

    var phoneText = details['phone number'] || details.phone || '';
    var emailText = details.email || '';
    var socialText =
      details['instagram/tiktok'] ||
      details['instagram / tiktok'] ||
      details['instagram and tiktok'] ||
      details.instagram ||
      '';

    var titleText = cleanText(title ? title.textContent : '') || 'Contact information';
    var config = window.otPolicyPageConfig || {};
    var contactPageUrl = config.contactPageUrl || '/pages/contact-us';
    var menuUrl = config.menuUrl || '/collections/all';
    var cateringUrl = config.cateringUrl || '/pages/parties-and-events#CateringQuoteForm';

    var phoneDigits = phoneText.replace(/\D/g, '');
    var phoneDial = phoneDigits;
    if (phoneDigits.length === 10) phoneDial = '1' + phoneDigits;
    var phoneHref = phoneDial ? 'tel:+' + phoneDial : '';

    var emailHref = emailText ? 'mailto:' + emailText : '';
    var socialHandle = cleanText(socialText);
    var socialSlug = socialHandle.replace(/^@/, '').trim();
    var instagramUrl = socialSlug ? 'https://www.instagram.com/' + encodeURIComponent(socialSlug) + '/' : '';
    var tiktokUrl = socialSlug ? 'https://www.tiktok.com/@' + encodeURIComponent(socialSlug) : '';

    var heroActions =
      buildButton(contactPageUrl, 'Contact Us', 'ot-policy-contact__button--primary') +
      buildButton(menuUrl, 'Explore the Menu', 'ot-policy-contact__button--secondary');

    var cards = [
      buildDetailCard({
        label: 'Company',
        title: companyName,
        copy: 'Handcrafted tanghulu, founder-led hospitality, and polished Bay Area service.',
        actions: [buildPill(menuUrl, 'Shop online', false), buildPill(cateringUrl, 'Plan an event', false)],
        modifier: 'ot-policy-contact__detail--brand'
      }),
      buildDetailCard({
        label: 'Phone',
        value: phoneText,
        href: phoneHref,
        copy: 'Call for time-sensitive order coordination and service questions.',
        actions: [buildPill(phoneHref, 'Call now', false)]
      }),
      buildDetailCard({
        label: 'Email',
        value: emailText,
        href: emailHref,
        copy: 'Use email for general inquiries, gifting questions, and larger order support.',
        actions: [buildPill(emailHref, 'Send email', false)]
      }),
      buildDetailCard({
        label: 'Instagram / TikTok',
        value: socialHandle,
        copy: 'Follow or message us for the latest drops, pop-ups, and behind-the-glaze updates.',
        actions: [buildPill(instagramUrl, 'Instagram', true), buildPill(tiktokUrl, 'TikTok', true)]
      })
    ]
      .filter(Boolean)
      .join('');

    body.innerHTML =
      '<div class="ot-policy-contact">' +
      '<section class="ot-policy-contact__hero">' +
      '<div class="ot-policy-contact__hero-copy">' +
      '<p class="ot-policy-contact__eyebrow">Bay Area hospitality</p>' +
      '<h1 class="ot-policy-contact__title">' +
      escapeHtml(titleText) +
      '</h1>' +
      '<p class="ot-policy-contact__lede">Reach ' +
      escapeHtml(companyName) +
      ' for pickup questions, delivery coordination, gifting help, and event planning across the Bay Area.</p>' +
      '<div class="ot-policy-contact__actions">' +
      heroActions +
      '</div>' +
      '</div>' +
      '<aside class="ot-policy-contact__hero-panel">' +
      '<p class="ot-policy-contact__panel-label">Best ways to reach us</p>' +
      '<h2 class="ot-policy-contact__panel-title">Support for everyday orders and special events</h2>' +
      '<ul class="ot-policy-contact__panel-list" role="list">' +
      '<li>Email for general questions, larger orders, and service support.</li>' +
      '<li>Call for urgent coordination and time-sensitive updates.</li>' +
      '<li>Use social for the latest drops, pop-ups, and brand updates.</li>' +
      '</ul>' +
      '</aside>' +
      '</section>' +
      '<section class="ot-policy-contact__details" aria-label="Contact details">' +
      cards +
      '</section>' +
      '</div>';

    container.classList.add('is-enhanced');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceContactPolicyPage);
  } else {
    enhanceContactPolicyPage();
  }
})();
